<template>
  <ContestsRewardTable :columns="table.columns" :rows="table.rows" />
</template>

<script>
import ContestsRewardTable from './ContestsRewardTable.vue'

export default {
  components: {
    ContestsRewardTable
  },
  props: {
    rewards: {
      type: Array,
      default: () => []
    }
  },
  emits: ['click', 'close'],
  data: () => {
    return {
      table: {
        columns: {
          reward: {
            id: 'reward',
            label: 'pages.contests.contestDetailPage.modal.reward',
            type: 'label'
          },
          rewardWon: {
            id: 'rewardWon',
            label: 'pages.contests.contestDetailPage.modal.rewardWon',
            type: 'label'
          }
        },
        rows: []
      }
    }
  },
  created() {
    this.tableUpdate()
  },
  methods: {
    tableUpdate() {
      const rows = []

      this.table.columns.rewardRetrieved = {
        id: 'rewardRetrieved',
        label: 'pages.contests.contestDetailPage.modal.rewardRetrieved',
        type: 'label'
      }
      this.rewards.forEach((row) => {
        rows.push({
          reward: row.name.fr,
          rewardWon: row.count_won_reward,
          rewardRetrieved: row.count_retrieved_reward
        })
      })

      this.table.rows = rows
    }
  }
}
</script>
